import { makeSvgIcon } from '../makeSvgIcon'

export const lightning = makeSvgIcon(
  <path d="M12 14L15 18L22.5 0L12 10L9 6L2 24L12 14Z" />
)
